var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobSharperShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f2eb00;\n      }\n\n      .cls-2 {\n        fill: #35202f;\n      }\n\n      .cls-3 {\n        fill: #301d29;\n      }\n\n      .cls-4 {\n        fill: #261722;\n      }\n\n      .cls-5 {\n        fill: #ff0068;\n      }\n\n      .cls-6 {\n        fill: #3f2738;\n      }\n\n      .cls-7 {\n        fill: #5b4956;\n      }\n\n      .cls-8 {\n        fill: #d60061;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "425.05 353.32 281.6 353.32 299.09 346.09 407.56 346.09 425.05 353.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "425.05 353.32 281.6 353.32 299.09 360.56 407.56 360.56 425.05 353.32"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "538.91 370.69 503.63 375.99 430.21 375.99 430.21 313.5 538.91 329.83 538.91 370.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "565.65 303.41 193.38 303.41 87.32 366.02 313.6 377.67 443.82 394.31 565.65 303.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "272.32 329.46 287.53 367.01 87.32 365.82 193.94 303.03 272.32 329.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "445.03 386.02 112.2 383.59 87.32 366.02 478.27 368.19 445.03 386.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "500.2 452.18 302.93 428.61 294.64 414.82 500.2 435.8 500.2 452.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "342.72 409.21 161.05 398.78 161.05 391.34 342.72 380.91 342.72 409.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "499.64 435.8 294.08 414.82 287.99 365.62 478.27 368.19 499.64 435.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "565.93 303.03 193.94 303.03 601.47 254.46 565.93 303.03"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "565.65 303.41 257.92 267.49 193.38 303.41"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobSharperShip);
export default __webpack_public_path__ + "static/media/mob-sharper-ship.ccef20fc37c8b775293d6a61bce33cb7.svg";
export { ForwardRef as ReactComponent };